export const REBATE_INSIGHTS = 'REBATE_INSIGHTS';
export const REBATE_LOAD = 'REBATE_LOAD';
export const REBATE_END = 'REBATE_END';